"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @description Create a hash of a strings contents.
 * @param {string} str  String content to be hashed
 * @returns {string}
 */
function contentHash(str) {
    var hash = 0;
    var i;
    var chr;
    if (str.length === 0)
        return hash.toString();
    /* eslint-disable no-bitwise */
    for (i = 0; i < str.length; i += 1) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0;
    }
    /* eslint-enable no-bitwise */
    return hash.toString();
}
exports.default = contentHash;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/browser-bundle/~/@flowio/cache/dist/src/util/content-hash.js
// module id = 501
// module chunks = 0 1